import { useEffect } from "react";
import { signal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import { useStore } from "storev2/formStore";
import { layout } from "./model/layoutVps";

const recId = signal(null);

function Vps() {
  const { newRecord } = useStore();

  async function initRecord() {
    const id = await newRecord(layout());
    recId.value = id;
  }

  useEffect(() => {
    initRecord();
  }, []);

  return (
    <div className="w-full space-y-4">
      <Board layout={layout()} />
    </div>
  );
}

export default Vps;
